var windowExists = typeof window !== 'undefined';
var getPgaTld = function getPgaTld() {
  if (windowExists) {
    return window.location.origin.includes('.sandboxpga.org') || window.location.origin.includes('.pga.local') ? 'sandboxpga.org' : 'pga.org';
  }
  return 'pga.org';
};
export default getPgaTld;